import forms from '@/script/viewscripts/common/forms';

export interface UrlSelectorOptions {
	protocolSelector: string;
	inputSelector: string;
}

export class UrlSelector {
	constructor (public options: UrlSelectorOptions) {
		const $urlProtocol = $(options.protocolSelector);
		const $urlInput = $(options.inputSelector);
		const clearProtocol = (val: string) => val.replace(/(^\w+:|^)\/\//, '');
		const setUrlProtocol = ($urlInput: JQuery<HTMLElement>, $protocolDropDown: JQuery<HTMLElement>,
			validProtocols: string[]) => {
			const val = ($urlInput.val() || '').toString();
			for (const protocol of validProtocols) {
				if (val.startsWith(protocol)) {
					$protocolDropDown.val(protocol);
					$urlInput.val(clearProtocol(val));
					break;
				}
			}
		};

		const validUrlProtocols: string[] = [];
		$urlProtocol.find('option').each((i, e) => {
			const optionVal = ($(e).val() || '').toString();
			validUrlProtocols.push(optionVal);
		});

		this.removeUrlValidation($urlInput);

		$urlInput.on('change', (event) => {
			const $this = $(event.currentTarget);
			setUrlProtocol($this, $urlProtocol, validUrlProtocols);
		});
		setUrlProtocol($urlInput, $urlProtocol, validUrlProtocols);
	}

	public get enteredUrl (): string {
		const transitionalPageUrlVal = forms.getInputValue(this.options.inputSelector);
		const transitionalPageUrlProtocol = forms.getDropdownSelectedValue(this.options.protocolSelector);
		return `${transitionalPageUrlProtocol}${transitionalPageUrlVal}`;
	}

	private removeUrlValidation ($urlInput: JQuery<HTMLElement>): void {
		($urlInput as any).rules('remove', 'url');
	}
}
